import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMedicalCross: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMedicalCross"><Path d="M16 8H22V16H16V22H8V16H2V8H8V2H16V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMedicalCross;
